// src/data/dictionary.js

export const dictionaryInfo = {
  name: "Nirakh Veshan",
  literalTranslation: {
    de: "Himmelssprache der Seele",
    en: "Heavenly Language of the Soul"
  },
  freeTranslation: {
    de: "Die Sprache der Seele des Himmels",
    en: "The Language of the Sky's Soul"
  },
  description: {
    de: "Nirakh Veshan ist keine neutrale Sprache, sondern die Sprache des Volkes von Longyún, der inneren Wahrheit und der Seelenbindung. Worte werden hier nicht nur gehört, sondern im Inneren körperlich gefühlt.",
    en: "Nirakh Veshan is not a neutral language, but the language of the people of Longyún, of inner truth and soul-binding. Words here are not merely heard, but physically felt within."
  }
};

export const dictionaryWords = [
  // Grundvokabeln
  { 
    word: "Khral", 
    pronunciation: "khral", 
    category: { de: "Grundlegendes", en: "Basics" },
    translation: { de: "Feuer", en: "Fire" }, 
    description: { de: "Die Lebensquelle.", en: "The source of life." } 
  },
  { 
    word: "Veshan", 
    pronunciation: "vesh-ahn", 
    category: { de: "Grundlegendes", en: "Basics" },
    translation: { de: "Seele", en: "Soul" }, 
    description: { de: "Das innere Leuchten eines Wesens.", en: "The inner glow of a being." } 
  },
  { 
    word: "Thal", 
    pronunciation: "thal", 
    category: { de: "Grundlegendes", en: "Basics" },
    translation: { de: "Bindung, Schwur", en: "Bond, Oath" }, 
    description: { de: "Eine heilige, unumkehrbare Verbindung.", en: "A sacred, irreversible connection." } 
  },
  { 
    word: "Zharu", 
    pronunciation: "zha-roo", 
    category: { de: "Grundlegendes", en: "Basics" },
    translation: { de: "König / Kaiser", en: "King / Emperor" }, 
    description: { de: "Wörtlich: 'Der vom Himmel Erwählte'.", en: "Literally: 'The one chosen by heaven'." } 
  },
  { 
    word: "Amesh", 
    pronunciation: "ah-mesh", 
    category: { de: "Grundlegendes", en: "Basics" },
    translation: { de: "Geliebte(r)", en: "Beloved" }, 
    description: { de: "Wörtlich: 'Teil meines Feuers'.", en: "Literally: 'Part of my fire'." } 
  },
  { 
    word: "Sōna", 
    pronunciation: "soo-nah", 
    category: { de: "Grundlegendes", en: "Basics" },
    translation: { de: "Blut", en: "Blood" }, 
    description: { de: "Symbol für die Linie, Herkunft und Vererbung.", en: "Symbol for lineage, origin, and inheritance." } 
  },
  { 
    word: "Nirakh", 
    pronunciation: "nee-rakh", 
    category: { de: "Grundlegendes", en: "Basics" },
    translation: { de: "Himmel", en: "Heaven / Sky" }, 
    description: { de: "Wörtlich: 'Ozean aus Licht'.", en: "Literally: 'Ocean of light'." } 
  },
  
  // Zeit & Tageszeiten
  { 
    word: "Darai", 
    pronunciation: "darai", 
    category: { de: "Zeit & Tageszeiten", en: "Time & Times of Day" },
    translation: { de: "Tag / Zeitspanne", en: "Day / Span of time" }, 
    description: { de: "Ein voller Licht-zu-Licht-Zyklus; bereits gelebte Zeit.", en: "A full light-to-light cycle; time already lived." } 
  },
  { 
    word: "Laira", 
    pronunciation: "laira", 
    category: { de: "Zeit & Tageszeiten", en: "Time & Times of Day" },
    translation: { de: "Morgen", en: "Morning" }, 
    description: { de: "Wörtlich: 'Erstes Licht'. Klingt weich, hoffnungsvoll, ideal für einen Neubeginn.", en: "Literally: 'First light'. Sounds soft, hopeful, ideal for a new beginning." } 
  },
  { 
    word: "Sahen", 
    pronunciation: "sahen", 
    category: { de: "Zeit & Tageszeiten", en: "Time & Times of Day" },
    translation: { de: "Mittag", en: "Noon" }, 
    description: { de: "Wörtlich: 'Stehendes Licht' (Sonne im Zenit). Sehr neutral und sachlich.", en: "Literally: 'Standing light' (sun at its zenith). Very neutral and objective." } 
  },
  { 
    word: "Sharan", 
    pronunciation: "sharan", 
    category: { de: "Zeit & Tageszeiten", en: "Time & Times of Day" },
    translation: { de: "Abend / Dämmerung", en: "Evening / Dusk" }, 
    description: { de: "Ein schützender Übergang. Steht für Intimität, Rituale und tiefe Gespräche.", en: "A protective transition. Stands for intimacy, rituals, and deep conversations." } 
  },
  { 
    word: "Noresh", 
    pronunciation: "noresh", 
    category: { de: "Zeit & Tageszeiten", en: "Time & Times of Day" },
    translation: { de: "Nacht", en: "Night" }, 
    description: { de: "Ruhende Zeit, schlafendes Feuer. Wird oft mit Wahrheit und Nähe verbunden.", en: "Resting time, sleeping fire. Often associated with truth and closeness." } 
  },
  
  // Zeitperioden
  { 
    word: "Kethar", 
    pronunciation: "kethar", 
    category: { de: "Zeitperioden", en: "Time Periods" },
    translation: { de: "Woche", en: "Week" }, 
    description: { de: "Wörtlich: 'Atem des Himmels'. Ein 7-Tage-Zyklus, orientiert an den Mondphasen.", en: "Literally: 'Breath of heaven'. A 7-day cycle, oriented around the lunar phases." } 
  },
  { 
    word: "Noreshar", 
    pronunciation: "noreshar", 
    category: { de: "Zeitperioden", en: "Time Periods" },
    translation: { de: "Monat", en: "Month" }, 
    description: { de: "Wörtlich: 'Ruhende Zeit'. Ein vollständiger Mondzyklus.", en: "Literally: 'Resting time'. A complete lunar cycle." } 
  },
  { 
    word: "Vethar", 
    pronunciation: "vethar", 
    category: { de: "Zeitperioden", en: "Time Periods" },
    translation: { de: "Jahr", en: "Year" }, 
    description: { de: "Wörtlich: 'Großer Kreis' / 'Rückkehr des Lichts'.", en: "Literally: 'Great circle' / 'Return of light'." } 
  },
  { 
    word: "Tharvesh", 
    pronunciation: "tharvesh", 
    category: { de: "Zeitperioden", en: "Time Periods" },
    translation: { de: "Ära / Lebensabschnitt", en: "Era / Stage of life" }, 
    description: { de: "Eine lange, oft historische oder schicksalhafte Zeitspanne (z.B. die Ära eines Kaisers).", en: "A long, often historical or fateful span of time (e.g., the era of an emperor)." } 
  },

  // Jahreszeiten
  { 
    word: "Laira’eth", 
    pronunciation: "laira-eth", 
    category: { de: "Jahreszeiten", en: "Seasons" },
    translation: { de: "Frühling", en: "Spring" }, 
    description: { de: "Wörtlich: 'Erwachendes Licht'. Steht für Geburt, Hoffnung, Hochzeiten und Reisen.", en: "Literally: 'Awakening light'. Stands for birth, hope, weddings, and journeys." } 
  },
  { 
    word: "Khral’eth", 
    pronunciation: "khral-eth", 
    category: { de: "Jahreszeiten", en: "Seasons" },
    translation: { de: "Sommer", en: "Summer" }, 
    description: { de: "Wörtlich: 'Zeit des Feuers'. Steht für Kraft, Wachstum, Krönungen und Feldzüge.", en: "Literally: 'Time of fire'. Stands for strength, growth, coronations, and military campaigns." } 
  },
  { 
    word: "Sharan’eth", 
    pronunciation: "sharan-eth", 
    category: { de: "Jahreszeiten", en: "Seasons" },
    translation: { de: "Herbst", en: "Autumn" }, 
    description: { de: "Wörtlich: 'Sanfter Übergang'. Steht für Ernte, Reflexion, Bündnisse und Abschiede.", en: "Literally: 'Gentle transition'. Stands for harvest, reflection, alliances, and farewells." } 
  },
  { 
    word: "Noresh’eth", 
    pronunciation: "noresh-eth", 
    category: { de: "Jahreszeiten", en: "Seasons" },
    translation: { de: "Winter", en: "Winter" }, 
    description: { de: "Wörtlich: 'Schlafende Welt'. Zeit des Rückzugs, der Seelenrituale und Geständnisse.", en: "Literally: 'Sleeping world'. Time of retreat, soul rituals, and confessions." } 
  },
  { 
    word: "Thal’khral", 
    pronunciation: "thal-khral", 
    category: { de: "Kultur & Phänomene", en: "Culture & Phenomena" },
    translation: { de: "Paarungszeit", en: "Mating Season" }, 
    description: { 
      de: "Wörtlich: 'Bindung des Feuers'. Eine biologisch und spirituell extrem intensive fünfte Jahreszeit zwischen Winter und Frühling. Gefühle können nicht mehr unterdrückt werden; Worte in dieser Zeit gelten als ewige, unumkehrbare Schwüre.", 
      en: "Literally: 'Bond of fire'. A biologically and spiritually intense fifth season between winter and spring. Feelings can no longer be suppressed; words spoken during this time are considered eternal, irreversible vows." 
    } 
  }
];

export const chapterTranslations = [
  {
    chapter: { de: "Kapitel 2", en: "Chapter 2" },
    phrases: [
      { 
        original: "Ameshesh veshan khrale veshir", 
        translation: { de: "Meine Geliebte/Mein Geliebter, meine Seele brennt in der deinen.", en: "My beloved, my soul burns within yours." }, 
        context: { de: "Sinngemäß: Ich liebe dich.", en: "Meaning: I love you." } 
      },
      { 
        original: "Shen lai veshir.", 
        translation: { de: "Ich sehe dein Licht.", en: "I see your light." }, 
        context: { de: "Traditionelle Begrüßung.", en: "Traditional greeting." } 
      },
      { 
        original: "Lai’an, eshanesh.", 
        translation: { de: "Licht dir, mein Herz.", en: "Light to you, my heart." }, 
        context: { de: "Gegenbegrüßung.", en: "Counter-greeting." } 
      },
      { 
        original: "Eshanesh shen veshir.", 
        translation: { de: "Mein Herz erkennt deines.", en: "My heart recognizes yours." }, 
        context: { de: "Begrüßung unter Liebenden.", en: "Greeting between lovers." } 
      }
    ]
  },
  {
    chapter: { de: "Kapitel 6", en: "Chapter 6" },
    phrases: [
      { 
        original: "Ameshesh veshan khrale veshir", 
        translation: { de: "Mein:e Geliebte:r, meine Seele brennt in der deinen.", en: "My beloved, my soul burns within yours." }, 
        context: { de: "Gesprochen von Zhènyáng.", en: "Spoken by Zhènyáng." } 
      },
      { 
        original: "Veshanesh khrale veshir’en, Amesh", 
        translation: { de: "Meine Seele brennt auch in der deinen, Geliebte:r.", en: "My soul burns within yours too, beloved." }, 
        context: { de: "Erwiderung von Zīxuě.", en: "Replied by Zīxuě." } 
      }
    ]
  },
  {
    chapter: { de: "Kapitel 11", en: "Chapter 11" },
    phrases: [
      {
        original: "Ameshesh, virenesh na shen. Veshir thale; nira na. Veshanesh neshai. Ameshesh, thalen veshir an vahan na shenai, thal neshai darai.",
        translation: { 
          de: "Mein Liebster, mach dir keine Sorgen. Vertraue mir; es ist nicht nötig. Mir geht es gut. Mein Liebster, ich muss dich um einen Weg bitten, den du nicht verstehen wirst, damit alles so bleibt.", 
          en: "My beloved, do not worry. Trust me; it is not necessary. I am well. My beloved, I must ask you for a path that you will not understand, so that everything remains as it is." 
        },
        context: { 
          de: "Liebster ich will wirklich, dass du dir keine Sorgen machst es ist wirklich nicht nötig vertraue mir. Mir geht es gut, aber ich muss dich um etwas sehr Unnachvollziehbares bitten damit das auch so bleibt.", 
          en: "Beloved, I truly want you not to worry, it is really not necessary, trust me. I am doing well, but I must ask you for something very incomprehensible so that it stays that way." 
        }
      }
    ]
  },
  {
    chapter: { de: "Kapitel 17 (Der Dialog zwischen Kaiser & Kaiserin)", en: "Chapter 17 (Dialogue between Emperor & Empress)" },
    phrases: [
      { 
        original: "Virenesh na shen.", 
        translation: { de: "Mach dir keine Sorgen.", en: "Do not worry." }, 
        context: { de: "Gesprochen vom Kaiser. (virenesh = Sorge/Sehnen, na shen = nicht sehen/loslassen)", en: "Spoken by the Emperor. (virenesh = worry/longing, na shen = not see/let go)" } 
      },
      { 
        original: "Daraian, talen neshai.", 
        translation: { de: "Heute wird alles vollkommen sein.", en: "Today everything will be perfect." }, 
        context: { de: "Gesprochen vom Kaiser. (neshai = vollkommener innerer Friede)", en: "Spoken by the Emperor. (neshai = perfect inner peace)" } 
      },
      { 
        original: "Sharanan thale eshanesh.", 
        translation: { de: "Der Abend gehört unserem Herzen.", en: "The evening belongs to our heart." }, 
        context: { de: "Gesprochen vom Kaiser. (sharan = intimer, geschützter Abend)", en: "Spoken by the Emperor. (sharan = intimate, protected evening)" } 
      },
      { 
        original: "Darai’an, veshan thal einsa.", 
        translation: { de: "Ab heute sind wir eins / eine Familie.", en: "From this day on we are one / a family." }, 
        context: { de: "Kaiser & Kaiserin. (einsa = vereint, wird ausschließlich für die Seelenbindung genutzt)", en: "Emperor & Empress. (einsa = united, used exclusively for soul-binding)" } 
      },
      { 
        original: "Thal’an veshan, vethar na endar.", 
        translation: { de: "Wir sind gebunden auf ewig.", en: "We are bound for eternity." }, 
        context: { de: "Gesprochen von der Kaiserin. (vethar na endar = ohne Ende eines Jahreskreises)", en: "Spoken by the Empress. (vethar na endar = without end of a year's cycle)" } 
      },
      { 
        original: "Na taren veshir, noresh na darai.", 
        translation: { de: "Ich lasse dich niemals gehen.", en: "I will never let you go." }, 
        context: { de: "Gesprochen von der Kaiserin. (na taren = bewusst aktives Nicht-gehen-lassen, noresh na darai = weder in der Nacht noch im Lauf der Zeit)", en: "Spoken by the Empress. (na taren = consciously active not-letting-go, noresh na darai = neither in the night nor over time)" } 
      },
      { 
        original: "Veshanesh khral.", 
        translation: { de: "Mein Seelenfeuer (Sinngemäß: Mein Schatz / Mein Ein und Alles)", en: "My soulfire (Meaning: My treasure / My everything)" }, 
        context: { de: "Gesprochen vom Kaiser. Höchst privat, wird niemals in der Öffentlichkeit verwendet.", en: "Spoken by the Emperor. Highly private, never used in public." } 
      }
    ]
  }
];